import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  container: {
    width: '90%',
    margin: '0 auto',
    marginTop: 40,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    fontSize: 12,
  },
  image: {
    width: 162,
    height: 38,
  },
  title: {
    fontSize: 14,
    margin: '30px 0px 40px 0px',
  },
  body: {
    height: 380,
    borderBottom: '1px solid #000',
  },
  bottom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
    marginTop: 10,
  },
  pageContainer: {
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  page: {
    textAlign: 'right',
  },
  tenPercentWrapper: {
    width: '9.5%',
    marginBottom: 10,
  },
  twentyPercentWrapper: {
    width: '19.5%',
    marginBottom: 10,
  },
  thirtyPercentWrapper: {
    width: '29.5%',
    marginBottom: 10,
  },
  thirtyTreePercentWrapper: {
    width: '32.5%',
    marginBottom: 10,
  },
  fortyPercentWrapper: {
    width: '39.5%',
    marginBottom: 10,
  },
  fiftyPercentWrapper: {
    width: '49.5%',
    marginBottom: 10,
  },
  sixtyPercentWrapper: {
    width: '59.5%',
    marginBottom: 10,
  },
  seventyPercentWrapper: {
    width: '69.5%',
  },
  eightyPercentWrapper: {
    width: '79.5%',
    marginBottom: 10,
  },
  ninetyPercentWrapper: {
    width: '89.5%',
    marginBottom: 10,
  },
  hundredPercentWrapper: {
    width: '100%',
    marginBottom: 10,
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  inlineText: {
    fontSize: 10,
    marginBottom: 10,
  },
  inlineTextCentered: {
    fontSize: 10,
    marginTop: 10,
    marginBottom: 10,
  },
  blackLine: {
    borderBottom: '1px solid #000',
    marginBottom: '20px',
  },
  oneThirdPageWrapperFlex: {
    width: '100%',
    height: '100px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  halfPageWrapper: {
    width: '100%',
    height: '300px',
  },
});
